export default {
  getRealnameUrl: '/f/realname/query', // 查询登录用户的企业实名信息
  verificationGenerateTokenUrl: '/f/verification/generateToken', // 人脸核验token生成
  verificationQueryUrl: '/f/verification/query', // 人脸核验结果查询
  getAppNewVersionUrl: '/f/app/getNewVersion', // 查看是否是最新版本
  checkCustManagerUrl: '/f/survey/managerWhiteList', // 客户经理白名单查询
  getInvestigatorSurveyListUrl: '/f/survey/investigatorSurveyList', // 获取当前登录尽调员的调研任务列表
  querySurveyBySurveyNoUrl: '/f/survey/querySurveyBySurveyNo', //  通过尽调编号查询尽调任务
  querySurveyByCodeUrl: '/f/survey/querySurveyByCode', // 通过尽调Code查询尽调任务
  bindMissionRelationUrl: '/f/survey/bindMissionRelation', // 通过尽调编号绑定尽调员和尽调任务
  getSurveyListUrl: '/f/survey/surveyList', // 获取当前登录用户的调研任务列表
  getSurveyListJDJRUrl: '/gw/generic/jindiao/h5/m/querySurveys', // 获取当前登录用户的调研任务列表
  getCategoryListUrl: '/f/survey/queryCategory', // 根据问卷编号查询问卷分类
  checkRequiredCategoryUrl: '/f/survey/checkRequired', // 检查是否存在未答的必答题
  getQuestionListUrl: '/f/survey/questionList', // 根据问卷编号、分类编码查询问题列表
  queryAnswerDetailUrl: '/f/survey/queryAnswerDetail', // 根据问卷编号、分类编码查询问题列表
  uploadFileUrl: '/f/surveyFile/upload', // 上传文件
  deleteFileByFileNoUrl: '/f/surveyFile/deleteFileByFileNo', // 单个删除附件，增加权限控制
  deleteBatchFileUrl: '/f/surveyFile/deleteBatch', // 删除文件
  getURLByFileNoUrl: '/f/surveyFile/getURLByFileNo', // 查看已上传文件
  getShareholderListUrl: '/f/shareholder/query', // 根据调研编号查询股东列表
  postShareholderListUrl: '/f/shareholder/save', // 保存、新增股东信息
  saveAnswerSurveyUrl: '/f/survey/saveAnswer', // 保存答案
  commitSurveyUrl: '/f/survey/commit', // 提交任务
  getAuditListUrl: '/f/message/getAuditList', // 用户的审批信息
  queryAuditMsgBySurveyNoUrl: '/f/message/listAuditBySurveyNo', // 用户的审批信息
  delShareholderUrl: '/f/shareholder/delShareholder', // 删除股东信息
  getPageContractUrl: '/f/contract/pageContract', // 获取当前登录用户的合同列表
  previewContractUrl: '/f/contract/preview', // 合同预览接口
  querySignUrl: '/f/contract/signUrlQuery', // 签约地址列表查询接口
  contractSignResultUrl: '/f/contract/signResult', // 签署结果提交接口(所有签约方式共用)
  contractPreSignQueryUrl: '/f/contract/preSignQuery' // 查询当前合同签署所需要的参数、签约方式、条件和权限
}



// WEBPACK FOOTER //
// ./src/http/requestUrl.js